angular.module('qkr').directive('chooseoutlet', () => {
    // Directive link function
    const link = function(scope, element, attrs) {
        let map, infoWindow;
        const markers = [];

        // Map config
        const mapOptions = {
            center: new google.maps.LatLng(43.69, -79.4),
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false
        };

        // Init the map
        function initMap() {
            if (map === void 0) {
                map = new google.maps.Map(element[0], mapOptions);
            }
        }

        // Place a marker
        function setMarker(map, position, title, content) {
            let marker;
            const markerOptions = {
                position,
                map,
                title,
                icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
            };

            marker = new google.maps.Marker(markerOptions);
            markers.push(marker); // Add marker to array

            google.maps.event.addListener(marker, 'click', () => {
                // Close window if not undefined
                if (infoWindow !== void 0) {
                    infoWindow.close();
                }
                // Create new window
                const infoWindowOptions = {
                    content
                };
                infoWindow = new google.maps.InfoWindow(infoWindowOptions);
                infoWindow.open(map, marker);
            });
        }

        // Show the map and place some markers
        initMap();

        for (let i = 0; i < 30; i++) {
            const randomLat = (Math.random() * (43.66 - 43.75) + 43.75).toFixed(4);
            const randomLong = (Math.random() * (78.9 - 79.3) - 79.3).toFixed(4);
            setMarker(map, new google.maps.LatLng(randomLat, randomLong, 'Outlet Example ' + i, 'Street Address Here'));
        }
    };

    return {
        restrict: 'A',
        template: '<div id="gmaps"></div>',
        replace: true,
        link
    };
});



// WEBPACK FOOTER //
// ./src/directives/maps/choose_outlet.js